import React, { useState } from 'react';
import { HelpCircle, MessageSquare, Scale, ShieldCheck, FileText } from 'lucide-react';
import { PrivacyModal, TermsModal, ContactModal } from './FooterModals';
import { LicenseAttributionModal } from './LicenseAttributionModal';
import { useWBL } from '../../context/WBLContext';
import { getRegionDarkBg } from '../../utils/regionUtils';
import { useInAppDialog } from './InAppDialog';

export function GlobalFooter({ className = "" }: { className?: string }) {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  
  const { activeTenant } = useWBL();
  const { showAlert } = useInAppDialog();

  return (
    <>
      <footer 
        className={`w-full py-6 flex flex-wrap items-center justify-center gap-x-12 gap-y-4 shrink-0 z-10 ${className}`}
        style={{ backgroundColor: activeTenant?.id ? getRegionDarkBg(activeTenant.id) : '#03142c' }}
      >
        <a 
          href="#help" 
          className="flex items-center space-x-2.5 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:text-slate-200 transition-colors"
          onClick={(e) => { 
            e.preventDefault(); 
            showAlert({
              title: "Help & Documentation",
              message: "Help desk documents and onboarding videos are accessible once authenticated into your regional workspace.",
              type: "info"
            });
          }}
        >
          <HelpCircle className="w-4 h-4 text-[#0091ca]" />
          <span>Help & Tutorials</span>
        </a>
        <a 
          href="#contact" 
          className="flex items-center space-x-2.5 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:text-slate-200 transition-colors"
          onClick={(e) => { 
            e.preventDefault(); 
            setShowContactModal(true); 
          }}
        >
          <MessageSquare className="w-4 h-4 text-[#0091ca]" />
          <span>Contact Us</span>
        </a>
        <a 
          href="#terms" 
          className="flex items-center space-x-2.5 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:text-slate-200 transition-colors"
          onClick={(e) => { 
            e.preventDefault(); 
            setShowTermsModal(true); 
          }}
        >
          <Scale className="w-4 h-4 text-[#0091ca]" />
          <span>Terms of Service</span>
        </a>
        <a 
          href="#privacy" 
          className="flex items-center space-x-2.5 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:text-slate-200 transition-colors"
          onClick={(e) => { 
            e.preventDefault(); 
            setShowPrivacyModal(true); 
          }}
        >
          <ShieldCheck className="w-4 h-4 text-[#0091ca]" />
          <span>Privacy Policy</span>
        </a>
        <a 
          href="#license" 
          className="flex items-center space-x-2.5 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:text-slate-200 transition-colors"
          onClick={(e) => { 
            e.preventDefault(); 
            setShowLicenseModal(true); 
          }}
        >
          <FileText className="w-4 h-4 text-[#0091ca]" />
          <span>License Attribution</span>
        </a>
      </footer>

      <PrivacyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} />
      <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
      <LicenseAttributionModal isOpen={showLicenseModal} onClose={() => setShowLicenseModal(false)} />
    </>
  );
}
